import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  Tooltip,
  IconButton,
  Badge,
  Menu,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Alert,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Drawer,
  Divider,
  Collapse,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { styled } from '@mui/material/styles';
import { Eye, EyeOff, RefreshCw, Search, User, Users as UsersIcon, FileText as FileTextIcon, Users as PasspClientsLogoIcon, Plus, Pencil } from 'lucide-react';
import { toast } from 'react-toastify';
import api from '../services/api';
import { useJob } from '../context/JobContext';
import { useNavigate } from 'react-router-dom';
import LoaderProgress from '../components/ui/loader-progress';
import { decodeCodiceFiscale } from '../utils/codiceFiscale';

const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
  borderRadius: 16,
  overflow: 'hidden',
}));

export default function PasspClientes() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState('');
  const [azienda, setAzienda] = useState('all');
  const [anno, setAnno] = useState('all');
  const [tipoPersona, setTipoPersona] = useState('all');
  const [regioneFiltro, setRegioneFiltro] = useState('all');
  const [aziendeOptions, setAziendeOptions] = useState([]);
  const [anniOptions, setAnniOptions] = useState([]);
  const [tipiPersonaOptions, setTipiPersonaOptions] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({
    id: false,
    denominazione: false,
    cognome: false,
    nome: false,
  });
  const [columnMenuAnchorEl, setColumnMenuAnchorEl] = useState(null);
  const [tipoPersonaStats, setTipoPersonaStats] = useState([]);
  const [loadingTipoPersonaStats, setLoadingTipoPersonaStats] = useState(false);
  const [regioneStats, setRegioneStats] = useState([]);
  const [loadingRegioneStats, setLoadingRegioneStats] = useState(false);
  const [showRegioneWidget, setShowRegioneWidget] = useState(false);
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncAzienda, setSyncAzienda] = useState('');
  const [syncAnno, setSyncAnno] = useState('');
  const [syncMode, setSyncMode] = useState('incremental');
  const [syncLatestDate, setSyncLatestDate] = useState(null);
  const [syncLatestDataUltMod, setSyncLatestDataUltMod] = useState(null);
  const [loadingSyncLatestDate, setLoadingSyncLatestDate] = useState(false);
  const [clienteDialogOpen, setClienteDialogOpen] = useState(false);
  const [clienteDialogMode, setClienteDialogMode] = useState('create');
  const [clienteDialogCodice, setClienteDialogCodice] = useState('');
  const [clienteDialogAzienda, setClienteDialogAzienda] = useState('');
  const [clienteDialogAnno, setClienteDialogAnno] = useState('');
  const [clienteDialogJson, setClienteDialogJson] = useState('{\n  \n}');
  const [clienteDialogSaving, setClienteDialogSaving] = useState(false);
  const [clienteDialogAdvanced, setClienteDialogAdvanced] = useState(false);
  const [clienteDialogUseJson, setClienteDialogUseJson] = useState(false);
  const [clienteDialogJsonTouched, setClienteDialogJsonTouched] = useState(false);
  const [clienteCodiceManual, setClienteCodiceManual] = useState(false);
  const [clienteCodiceHint, setClienteCodiceHint] = useState({ lastCodice: '', nextCodice: '' });
  const [clienteFormErrors, setClienteFormErrors] = useState({});
  const [clienteForm, setClienteForm] = useState({
    codice: '',
    gest_per_fisica: 'S',
    tp_nazionalita: 'I',
    cod_listino: '1',
    ragione_sociale: '',
    cognome: '',
    nome: '',
    dt_nasc_cost: '',
    loc_nasc_cost: '',
    prv_nasc_cost: '',
    indirizzo: '',
    cap: '',
    localita: '',
    provincia: '',
    partita_iva: '',
    codice_fiscale: '',
    email: '',
    pec: '',
    telefono: '',
  });
  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);
  const [duplicateDialogMessage, setDuplicateDialogMessage] = useState('');
  const [duplicateDialogMatches, setDuplicateDialogMatches] = useState([]);
  const { addJob, jobs, addMonitoringNotification } = useJob();
  const navigate = useNavigate();
  const [invoiceDrawerOpen, setInvoiceDrawerOpen] = useState(false);
  const [invoiceClient, setInvoiceClient] = useState(null);
  const [invoiceRows, setInvoiceRows] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoicePage, setInvoicePage] = useState(0);
  const [invoiceRowsPerPage, setInvoiceRowsPerPage] = useState(10);
  const [invoiceTypeFilter, setInvoiceTypeFilter] = useState('all');
  const [invoiceOrder, setInvoiceOrder] = useState('desc');

  const optionalColumnsActive =
    columnVisibility.id ||
    columnVisibility.denominazione ||
    columnVisibility.cognome ||
    columnVisibility.nome;

  const baseColumnsCount = 7;
  const extraColumnsCount =
    (columnVisibility.id ? 1 : 0) +
    (columnVisibility.denominazione ? 1 : 0) +
    (columnVisibility.cognome ? 1 : 0) +
    (columnVisibility.nome ? 1 : 0);
  const totalColumns = baseColumnsCount + extraColumnsCount;

  const totalByTipoPersona = tipoPersonaStats.reduce((sum, item) => sum + (item.count || 0), 0);

  const getTipoPersonaVisuals = (tipo) => {
    if (tipo === 'S') {
      return {
        icon: User,
        iconBg: 'rgba(59, 130, 246, 0.12)',
        iconColor: '#2563EB',
        borderColor: 'rgba(59, 130, 246, 0.28)',
      };
    }

    if (tipo === 'N') {
      return {
        icon: UsersIcon,
        iconBg: 'rgba(16, 185, 129, 0.12)',
        iconColor: '#059669',
        borderColor: 'rgba(16, 185, 129, 0.28)',
      };
    }

    return {
      icon: UsersIcon,
      iconBg: 'rgba(148, 163, 184, 0.12)',
      iconColor: '#4B5563',
      borderColor: 'rgba(148, 163, 184, 0.28)',
    };
  };

  const TipoPersonaDonut = ({ value, color }) => {
    const safeValue = Number.isFinite(value) ? value : 0;
    const clamped = Math.max(0, Math.min(100, safeValue));

    return (
      <Box
        sx={{
          position: 'relative',
          width: 56,
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          variant="determinate"
          value={100}
          size={56}
          thickness={5}
          sx={{ color: 'rgba(148, 163, 184, 0.2)' }}
        />
        <CircularProgress
          variant="determinate"
          value={clamped}
          size={56}
          thickness={5}
          sx={{
            color,
            position: 'absolute',
            left: 0,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {`${clamped.toFixed(1)}%`}
          </Typography>
        </Box>
      </Box>
    );
  };

  const totalByRegione = regioneStats.reduce((sum, item) => sum + (item.count || 0), 0);

  const fetchFilters = async () => {
    try {
      const res = await api.get('/passp-clientes/filters/options');
      const data = res.data || {};
      setAziendeOptions((data.aziende || []).filter(Boolean));
      setAnniOptions((data.anni || []).filter(Boolean));
      setTipiPersonaOptions((data.tipiPersona || []).filter(Boolean));
    } catch (error) {
      console.error('Error fetching Passpartout clients filters:', error);
      toast.error('Errore nel caricamento dei filtri Clienti Passpartout');
    }
  };

  const fetchTipoPersonaStats = async () => {
    try {
      setLoadingTipoPersonaStats(true);
      const params = {};
      if (search) params.search = search;
      if (azienda !== 'all') params.azienda = azienda;
      if (anno !== 'all') params.anno = anno;
      const res = await api.get('/passp-clientes/stats/tipo-persona', { params });
      const data = res.data || {};
      setTipoPersonaStats(Array.isArray(data.items) ? data.items : []);
    } catch (error) {
      console.error('Error fetching Passpartout tipo persona stats:', error);
    } finally {
      setLoadingTipoPersonaStats(false);
    }
  };

  const fetchRegioneStats = async () => {
    try {
      setLoadingRegioneStats(true);
      const params = {};
      if (search) params.search = search;
      if (azienda !== 'all') params.azienda = azienda;
      if (anno !== 'all') params.anno = anno;
      const res = await api.get('/passp-clientes/stats/regione', { params });
      const data = res.data || {};
      setRegioneStats(Array.isArray(data.items) ? data.items : []);
    } catch (error) {
      console.error('Error fetching Passpartout regione stats:', error);
    } finally {
      setLoadingRegioneStats(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        page: page + 1,
        limit: rowsPerPage,
        orderBy,
        orderDirection: order,
      };
      if (search) params.search = search;
      if (azienda !== 'all') params.azienda = azienda;
      if (anno !== 'all') params.anno = anno;
      if (tipoPersona !== 'all') params.gestPerFisica = tipoPersona;
      if (regioneFiltro !== 'all') params.regione = regioneFiltro;

      const res = await api.get('/passp-clientes', { params });
      const data = res.data || {};
      setRows(Array.isArray(data.data) ? data.data : []);
      setTotalItems(data.total || 0);
    } catch (error) {
      console.error('Error fetching Passpartout clients:', error);
      toast.error('Errore nel caricamento Clienti Passpartout');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, order, orderBy]);

  useEffect(() => {
    fetchTipoPersonaStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, azienda, anno]);
  
  useEffect(() => {
    if (!showRegioneWidget) return;
    fetchRegioneStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, azienda, anno, showRegioneWidget]);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === 'Enter') {
      setPage(0);
      fetchData();
    }
  };

  const handleFilterAzienda = (event) => {
    setAzienda(event.target.value);
    setPage(0);
  };

  const handleFilterAnno = (event) => {
    setAnno(event.target.value);
    setPage(0);
  };

  const handleOpenSyncDialog = () => {
    const defaultAzienda = azienda !== 'all' ? azienda : (aziendeOptions[0]?.code || '');
    setSyncAzienda(defaultAzienda);
    const defaultAnno =
      anno !== 'all'
        ? anno
        : anniOptions.length > 0
        ? String(anniOptions[0])
        : '';
    setSyncAnno(defaultAnno);
    setSyncMode('incremental');
    setSyncLatestDate(null);
    setSyncLatestDataUltMod(null);
    setSyncDialogOpen(true);
  };

  const handleCloseSyncDialog = () => {
    if (syncing) return;
    setSyncDialogOpen(false);
  };

  const handleConfirmSync = async () => {
    if (!syncAzienda || !syncAnno) {
      toast.error('Seleziona azienda e anno per la sincronizzazione');
      return;
    }
    setSyncing(true);
    const pendingToastId = toast.loading('Avvio sincronizzazione Clienti Passpartout...');
    try {
      const today = new Date();
      const todayYmd = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
        today.getDate()
      ).padStart(2, '0')}`;
      const res = await api.post('/passp-clientes/sync', {
        azienda: syncAzienda,
        anno: parseInt(syncAnno, 10),
        mode: syncMode,
        date_from: syncMode === 'incremental' ? syncLatestDataUltMod || todayYmd : undefined,
        date_to: syncMode === 'incremental' ? todayYmd : undefined,
      });
      const startMessage = res.data?.message || 'Sincronizzazione Clienti Passpartout avviata';
      if (res.data?.jobId) {
        addJob(res.data.jobId, 'passp_clienti_sync', { silent: true });
        toast.update(pendingToastId, {
          render: startMessage,
          type: 'success',
          isLoading: false,
          autoClose: 2500,
        });
        setSyncDialogOpen(false);
      } else {
        toast.update(pendingToastId, {
          render: startMessage,
          type: 'success',
          isLoading: false,
          autoClose: 2500,
        });
        setSyncDialogOpen(false);
        setAzienda(syncAzienda);
        setAnno(String(syncAnno));
        setPage(0);
        fetchData();
        fetchTipoPersonaStats();
        if (showRegioneWidget) fetchRegioneStats();
      }
    } catch (error) {
      console.error('Error syncing Passpartout clients:', error);
      toast.update(pendingToastId, {
        render: 'Errore durante la sincronizzazione Clienti Passpartout',
        type: 'error',
        isLoading: false,
        autoClose: 4000,
      });
    } finally {
      setSyncing(false);
    }
  };

  useEffect(() => {
    const fetchLatestDate = async () => {
      if (!syncDialogOpen || !syncAzienda || !syncAnno || syncMode !== 'incremental') {
        return;
      }
      setLoadingSyncLatestDate(true);
      try {
        const res = await api.get('/passp-clientes/sync/latest-date', {
          params: {
            azienda: syncAzienda,
            anno: parseInt(syncAnno, 10),
          },
        });
        setSyncLatestDate(res.data?.latestDate || null);
        setSyncLatestDataUltMod(res.data?.latestDataUltMod || null);
      } catch (error) {
        setSyncLatestDate(null);
        setSyncLatestDataUltMod(null);
        toast.error('Errore nel recupero ultima data modifica clienti');
      } finally {
        setLoadingSyncLatestDate(false);
      }
    };
    fetchLatestDate();
  }, [syncDialogOpen, syncAzienda, syncAnno, syncMode]);

  const formatDisplayDate = (value) => {
    if (!value || typeof value !== 'string') return value;
    const parts = value.split('-');
    if (parts.length !== 3) return value;
    const [yyyy, mm, dd] = parts;
    return `${dd}/${mm}/${yyyy}`;
  };

  const pickDefaultAzienda = () => {
    return azienda !== 'all' ? azienda : (aziendeOptions[0]?.code || '');
  };

  const pickDefaultAnno = () => {
    if (anno !== 'all') return String(anno);
    return anniOptions.length > 0 ? String(anniOptions[0]) : '';
  };

  const normalizeString = (value) => {
    const s = String(value || '').trim();
    return s;
  };

  const normalizeAlnumUpper = (value) => {
    return String(value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .trim();
  };

  const normalizeCodiceFiscale = (value) => {
    const v = normalizeAlnumUpper(value);
    if (v.startsWith('IT') && /^\d{11}$/.test(v.slice(2))) return v.slice(2);
    return v;
  };

  const normalizePartitaIva = (value) => {
    return normalizeAlnumUpper(value);
  };

  const pickOrEmpty = (value) => {
    const s = normalizeString(value);
    return s ? s : '';
  };

  const computeRagioneSociale = (form) => {
    const gest = String(form?.gest_per_fisica || '').trim().toUpperCase() === 'S' ? 'S' : 'N';
    if (gest === 'S') {
      return [form?.cognome, form?.nome].map((v) => normalizeString(v)).filter(Boolean).join(' ');
    }
    return normalizeString(form?.ragione_sociale);
  };

  const ragioneSocialeComputed = useMemo(() => computeRagioneSociale(clienteForm), [
    clienteForm.cognome,
    clienteForm.gest_per_fisica,
    clienteForm.nome,
    clienteForm.ragione_sociale,
  ]);

  const parseClientePayloadToForm = (payload) => {
    const obj = payload && typeof payload === 'object' ? payload : {};
    const gest =
      obj.gest_per_fisica ||
      obj.gestPerFisica ||
      obj.gestperfisica ||
      obj.tipo_persona ||
      obj.tipoPersona ||
      'N';
    const gestNorm = String(gest || 'N').trim().toUpperCase() === 'S' ? 'S' : 'N';
    const tp = String(obj.tp_nazionalita || obj.tpNazionalita || 'I').trim().toUpperCase();
    const tpNorm = ['I', 'C', 'E', 'R', 'V'].includes(tp) ? tp : 'I';

    return {
      codice: pickOrEmpty(obj.codice || obj.cod_cliente || obj.Codice || obj.CodCliente),
      gest_per_fisica: gestNorm,
      tp_nazionalita: tpNorm,
      cod_listino: pickOrEmpty(obj.cod_listino || obj.codListino || '1') || '1',
      ragione_sociale: pickOrEmpty(obj.ragione_sociale || obj.ragioneSociale),
      cognome: pickOrEmpty(obj.cognome),
      nome: pickOrEmpty(obj.nome),
      dt_nasc_cost: pickOrEmpty(obj.dt_nasc_cost || obj.dtNascCost || obj.data_nascita || obj.dataNascita),
      loc_nasc_cost: pickOrEmpty(obj.loc_nasc_cost || obj.locNascCost || obj.luogo_nascita || obj.luogoNascita),
      prv_nasc_cost: pickOrEmpty(obj.prv_nasc_cost || obj.prvNascCost || obj.provincia_nascita || obj.provinciaNascita),
      indirizzo: pickOrEmpty(obj.indirizzo),
      cap: pickOrEmpty(obj.cap),
      localita: pickOrEmpty(obj.localita),
      provincia: pickOrEmpty(obj.provincia),
      partita_iva: pickOrEmpty(obj.partita_iva || obj.partitaIva || obj.piva),
      codice_fiscale: pickOrEmpty(obj.codice_fiscale || obj.codiceFiscale || obj.cf),
      email: pickOrEmpty(obj.email),
      pec: pickOrEmpty(obj.pec),
      telefono: pickOrEmpty(obj.telefono),
    };
  };

  const buildClientePayloadFromForm = (formOverride, options = {}) => {
    const { keepEmpty = false } = options || {};
    const form = formOverride || clienteForm;
    const computedRagione = computeRagioneSociale(form);
    const normalizeOptional = (value) => {
      const raw = String(value ?? '');
      const trimmed = raw.trim();
      if (trimmed) return trimmed;
      return keepEmpty ? '' : undefined;
    };
    const normalizedPiva = normalizePartitaIva(form.partita_iva);
    const normalizedCf = normalizeCodiceFiscale(form.codice_fiscale);
    const payload = {
      codice: normalizeOptional(form.codice),
      gest_per_fisica: form.gest_per_fisica,
      tp_nazionalita: ['I', 'C', 'E', 'R', 'V'].includes(String(form.tp_nazionalita || '').toUpperCase())
        ? String(form.tp_nazionalita || '').toUpperCase()
        : 'I',
      cod_listino: 1,
      valuta: 1,
      ragione_sociale: computedRagione || undefined,
      cognome: pickOrEmpty(form.cognome) || undefined,
      nome: pickOrEmpty(form.nome) || undefined,
      dt_nasc_cost: normalizeOptional(form.dt_nasc_cost),
      loc_nasc_cost: normalizeOptional(form.loc_nasc_cost),
      prv_nasc_cost: normalizeOptional(form.prv_nasc_cost),
      indirizzo: pickOrEmpty(form.indirizzo) || undefined,
      cap: pickOrEmpty(form.cap) || undefined,
      localita: pickOrEmpty(form.localita) || undefined,
      provincia: pickOrEmpty(form.provincia) || undefined,
      partita_iva: normalizedPiva ? normalizedPiva : undefined,
      codice_fiscale: normalizedCf ? normalizedCf : undefined,
      email: normalizeOptional(form.email),
      pec: normalizeOptional(form.pec),
      telefono: normalizeOptional(form.telefono),
    };

    if (form.gest_per_fisica !== 'S') {
      if (!payload.cognome && payload.ragione_sociale) {
        payload.cognome = payload.ragione_sociale;
      }
      delete payload.nome;
      delete payload.dt_nasc_cost;
      delete payload.loc_nasc_cost;
      delete payload.prv_nasc_cost;
    } else {
      delete payload.ragione_sociale;
      if (computedRagione) {
        payload.ragione_sociale = computedRagione;
      }
    }

    return Object.fromEntries(Object.entries(payload).filter(([, v]) => v !== undefined));
  };

  const syncJsonFromFormIfNeeded = () => {
    if (clienteDialogJsonTouched) return;
    const payload = buildClientePayloadFromForm(null, { keepEmpty: clienteDialogMode === 'edit' });
    setClienteDialogJson(JSON.stringify(payload, null, 2));
  };

  useEffect(() => {
    let alive = true;
    const run = async () => {
      if (!clienteDialogOpen) return;
      if (clienteDialogUseJson) return;
      if (clienteForm.gest_per_fisica !== 'S') return;
      const cf = normalizeCodiceFiscale(clienteForm.codice_fiscale);
      if (cf.length !== 16) return;
      if (clienteForm.dt_nasc_cost || clienteForm.loc_nasc_cost || clienteForm.prv_nasc_cost) return;

      const decoded = await decodeCodiceFiscale(cf);
      if (!alive) return;
      if (!decoded) return;

      setClienteForm((prev) => {
        if (prev.gest_per_fisica !== 'S') return prev;
        if (normalizeCodiceFiscale(prev.codice_fiscale) !== cf) return prev;
        if (prev.dt_nasc_cost || prev.loc_nasc_cost || prev.prv_nasc_cost) return prev;
        const next = {
          ...prev,
          dt_nasc_cost: decoded.birthDateYmd || '',
          loc_nasc_cost: decoded.birthPlaceName || '',
          prv_nasc_cost: decoded.birthProvince || '',
        };
        if (!clienteDialogJsonTouched) {
          setClienteDialogJson(
            JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
          );
        }
        return next;
      });
    };
    run();
    return () => {
      alive = false;
    };
  }, [
    clienteDialogOpen,
    clienteDialogUseJson,
    clienteDialogMode,
    clienteDialogJsonTouched,
    clienteForm.gest_per_fisica,
    clienteForm.codice_fiscale,
    clienteForm.dt_nasc_cost,
    clienteForm.loc_nasc_cost,
    clienteForm.prv_nasc_cost,
  ]);

  const buildClienteJsonFromRow = (row) => {
    const base = {
      codice: row?.codice || undefined,
      gest_per_fisica: row?.gest_per_fisica || undefined,
      ragione_sociale: row?.ragione_sociale || undefined,
      denominazione: row?.denominazione || undefined,
      cognome: row?.cognome || undefined,
      nome: row?.nome || undefined,
      dt_nasc_cost: row?.dt_nasc_cost || undefined,
      loc_nasc_cost: row?.loc_nasc_cost || undefined,
      prv_nasc_cost: row?.prv_nasc_cost || undefined,
      indirizzo: row?.indirizzo || undefined,
      cap: row?.cap || undefined,
      localita: row?.localita || undefined,
      provincia: row?.provincia || undefined,
      regione: row?.regione || undefined,
      partita_iva: row?.partita_iva || undefined,
      codice_fiscale: row?.codice_fiscale || undefined,
      email: row?.email || undefined,
      pec: row?.pec || undefined,
      telefono: row?.telefono || undefined,
    };

    const cleaned = Object.fromEntries(Object.entries(base).filter(([, v]) => v !== undefined && v !== null && v !== ''));
    return JSON.stringify(cleaned, null, 2);
  };

  const buildClienteJsonFromMatch = (match) => {
    const obj = match && typeof match === 'object' ? match : {};
    const cleaned = Object.fromEntries(
      Object.entries(obj).filter(([k, v]) => {
        if (v === undefined || v === null || v === '') return false;
        if (k === 'id' || k === 'azienda' || k === 'anno') return false;
        return true;
      })
    );
    return JSON.stringify(cleaned, null, 2);
  };

  const getClienteCodiceFromMatch = (match) => {
    if (!match || typeof match !== 'object') return '';
    return (
      match.codice ||
      match.cod_cliente ||
      match.Codice ||
      match.CodCliente ||
      match.codConto ||
      ''
    );
  };

  const getClienteDisplayName = (match) => {
    if (!match || typeof match !== 'object') return '-';
    return (
      match.ragione_sociale ||
      match.denominazione ||
      [match.cognome, match.nome].filter(Boolean).join(' ') ||
      match.descrizione ||
      '-'
    );
  };

  const handleCloseDuplicateDialog = () => {
    setDuplicateDialogOpen(false);
    setDuplicateDialogMessage('');
    setDuplicateDialogMatches([]);
  };

  const handleOpenEditFromDuplicateMatch = (match) => {
    const codice = getClienteCodiceFromMatch(match);
    if (!codice) return;
    const form = parseClientePayloadToForm(match);
    setClienteDialogMode('edit');
    setClienteDialogCodice(String(codice));
    setClienteDialogAzienda(clienteDialogAzienda || pickDefaultAzienda());
    setClienteDialogAnno(clienteDialogAnno || pickDefaultAnno());
    setClienteDialogJsonTouched(false);
    setClienteDialogAdvanced(false);
    setClienteDialogUseJson(false);
    setClienteFormErrors({});
    setClienteForm(form);
    setClienteDialogJson(JSON.stringify(buildClientePayloadFromForm(form, { keepEmpty: true }), null, 2));
    setClienteDialogOpen(true);
    setDuplicateDialogOpen(false);
  };

  const fetchNextCodice = async (aziendaValue, annoValue) => {
    const aziendaSafe = String(aziendaValue || '').trim();
    const annoSafe = String(annoValue || '').trim();
    if (!aziendaSafe || !annoSafe) return null;
    try {
      const res = await api.get('/passp-clientes/next-code', {
        params: { azienda: aziendaSafe, anno: parseInt(annoSafe, 10) },
      });
      const next = res.data?.nextCodice ? String(res.data.nextCodice).trim() : '';
      const last = res.data?.lastCodice ? String(res.data.lastCodice).trim() : '';
      const nextCodice = next || null;
      if (nextCodice) {
        setClienteCodiceHint({ lastCodice: last || '', nextCodice });
      } else {
        setClienteCodiceHint({ lastCodice: '', nextCodice: '' });
      }
      return nextCodice;
    } catch (e) {
      const status = e?.response?.status;
      if (status === 404) {
        toast.warning('Impossibile suggerire il codice: esegui prima una sincronizzazione completa dei clienti.');
      } else {
        toast.error('Errore nel recupero del prossimo codice cliente');
      }
      setClienteCodiceHint({ lastCodice: '', nextCodice: '' });
      return null;
    }
  };

  const handleOpenCreateCliente = async () => {
    const defaultForm = {
      codice: '',
      gest_per_fisica: 'S',
      tp_nazionalita: 'I',
      cod_listino: '1',
      ragione_sociale: '',
      cognome: '',
      nome: '',
      dt_nasc_cost: '',
      loc_nasc_cost: '',
      prv_nasc_cost: '',
      indirizzo: '',
      cap: '',
      localita: '',
      provincia: '',
      partita_iva: '',
      codice_fiscale: '',
      email: '',
      pec: '',
      telefono: '',
    };
    setClienteDialogMode('create');
    setClienteDialogCodice('');
    const nextAzienda = pickDefaultAzienda();
    const nextAnno = pickDefaultAnno();
    setClienteDialogAzienda(nextAzienda);
    setClienteDialogAnno(nextAnno);
    setClienteDialogJsonTouched(false);
    setClienteDialogAdvanced(false);
    setClienteDialogUseJson(false);
    setClienteCodiceManual(false);
    setClienteCodiceHint({ lastCodice: '', nextCodice: '' });
    setClienteFormErrors({});
    setClienteForm(defaultForm);
    setClienteDialogJson(JSON.stringify(buildClientePayloadFromForm(defaultForm, { keepEmpty: false }), null, 2));
    setClienteDialogOpen(true);

    const nextCodice = await fetchNextCodice(nextAzienda, nextAnno);
    if (nextCodice) {
      setClienteCodiceManual(false);
      setClienteForm((prev) => {
        const merged = { ...prev, codice: nextCodice };
        if (!clienteDialogJsonTouched) {
          setClienteDialogJson(JSON.stringify(buildClientePayloadFromForm(merged, { keepEmpty: false }), null, 2));
        }
        return merged;
      });
    }
  };

  const handleOpenEditCliente = (row) => {
    const form = parseClientePayloadToForm(row);
    setClienteDialogMode('edit');
    setClienteDialogCodice(row?.codice || '');
    setClienteDialogAzienda(row?.azienda || pickDefaultAzienda());
    setClienteDialogAnno(row?.anno ? String(row.anno) : pickDefaultAnno());
    setClienteDialogJsonTouched(false);
    setClienteDialogAdvanced(false);
    setClienteDialogUseJson(false);
    setClienteFormErrors({});
    setClienteForm(form);
    setClienteDialogJson(JSON.stringify(buildClientePayloadFromForm(form, { keepEmpty: true }), null, 2));
    setClienteDialogOpen(true);
  };

  const handleCloseClienteDialog = () => {
    if (clienteDialogSaving) return;
    setClienteDialogOpen(false);
  };

  useEffect(() => {
    const run = async () => {
      if (!clienteDialogOpen) return;
      if (clienteDialogMode !== 'create') return;
      if (clienteDialogUseJson) return;
      if (!clienteDialogAzienda || !clienteDialogAnno) return;
      if (normalizeString(clienteForm.codice)) return;

      const next = await fetchNextCodice(clienteDialogAzienda, clienteDialogAnno);
      if (!next) return;
      setClienteCodiceManual(false);
      setClienteForm((prev) => {
        if (normalizeString(prev.codice)) return prev;
        const merged = { ...prev, codice: next };
        if (!clienteDialogJsonTouched) {
          setClienteDialogJson(JSON.stringify(buildClientePayloadFromForm(merged, { keepEmpty: false }), null, 2));
        }
        return merged;
      });
    };
    run();
  }, [clienteDialogOpen, clienteDialogMode, clienteDialogUseJson, clienteDialogAzienda, clienteDialogAnno]);

  const handleSaveClienteDialog = async () => {
    setClienteFormErrors({});
    if (!clienteDialogAzienda || !clienteDialogAnno) {
      toast.error('Seleziona azienda e anno');
      return;
    }

    if (clienteDialogMode === 'edit' && !clienteDialogCodice) {
      toast.error('Codice cliente mancante');
      return;
    }

    const errors = {};
    if (clienteForm.gest_per_fisica === 'S') {
      if (!normalizeString(clienteForm.cognome)) errors.cognome = true;
      if (!normalizeString(clienteForm.nome)) errors.nome = true;
    } else {
      if (!normalizeString(clienteForm.ragione_sociale)) errors.ragione_sociale = true;
    }
    if (clienteDialogMode === 'create') {
      const cf = normalizeCodiceFiscale(clienteForm.codice_fiscale);
      const piva = normalizePartitaIva(clienteForm.partita_iva);
      if (!cf && !piva) {
        errors.codice_fiscale = true;
        errors.partita_iva = true;
      }
    }

    if (Object.keys(errors).length > 0) {
      setClienteFormErrors(errors);
      toast.error('Compila i campi obbligatori');
      return;
    }

    let clientePayload = null;
    if (clienteDialogMode === 'create' && !clienteDialogUseJson && !normalizeString(clienteForm.codice)) {
      const next = await fetchNextCodice(clienteDialogAzienda, clienteDialogAnno);
      if (next) {
        setClienteForm((prev) => ({ ...prev, codice: next }));
      } else {
        setClienteFormErrors((prev) => ({ ...prev, codice: true }));
        toast.error('Codice cliente mancante (non è stato possibile calcolarlo automaticamente)');
        return;
      }
    }

    if (clienteDialogUseJson) {
      let parsed = null;
      try {
        parsed = JSON.parse(clienteDialogJson || '{}');
      } catch {
        toast.error('JSON non valido');
        return;
      }
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        toast.error('Il payload deve essere un oggetto JSON');
        return;
      }
      clientePayload = parsed;
    } else {
      clientePayload = buildClientePayloadFromForm(null, { keepEmpty: clienteDialogMode === 'edit' });
      setClienteDialogJsonTouched(false);
      setClienteDialogJson(JSON.stringify(clientePayload, null, 2));
    }

    setClienteDialogSaving(true);
    const pendingToastId = toast.loading(
      clienteDialogMode === 'create' ? 'Creazione cliente su Passpartout...' : 'Aggiornamento cliente su Passpartout...'
    );
    try {
      const payload = {
        azienda: clienteDialogAzienda,
        anno: parseInt(clienteDialogAnno, 10),
        cliente: clientePayload,
      };

      const res =
        clienteDialogMode === 'create'
          ? await api.post('/passp-clientes/remote', payload)
          : await api.put(`/passp-clientes/remote/${encodeURIComponent(clienteDialogCodice)}`, payload);

      if (res.data?.syncJobId) {
        addJob(res.data.syncJobId, 'passp_clienti_sync', { silent: true });
      }
      toast.update(pendingToastId, {
        render: res.data?.message || 'Operazione completata',
        type: 'success',
        isLoading: false,
        autoClose: 2500,
      });
      setClienteDialogOpen(false);
      fetchData();
    } catch (error) {
      const message = error?.response?.data?.message || 'Errore su Passpartout';
      const details = error?.response?.data?.details;
      const status = error?.response?.status;
      const matches = Array.isArray(details?.matches) ? details.matches : [];
      if (status === 409 && matches.length > 0) {
        setDuplicateDialogMessage(message);
        setDuplicateDialogMatches(matches);
        setDuplicateDialogOpen(true);
        toast.update(pendingToastId, {
          render: message,
          type: 'warning',
          isLoading: false,
          autoClose: 2500,
        });
        return;
      }
      const formatDetails = (value) => {
        if (!value) return null;
        const raw = typeof value === 'string' ? value : JSON.stringify(value);
        const cleaned = String(raw || '').replace(/\s+/g, ' ').trim();
        if (!cleaned) return null;
        return cleaned.length > 280 ? `${cleaned.slice(0, 280)}...` : cleaned;
      };
      const shortDetails = formatDetails(details);
      toast.update(pendingToastId, {
        render: shortDetails ? `${message}: ${shortDetails}` : message,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      setClienteDialogSaving(false);
    }
  };

  useEffect(() => {
    const syncJobs = jobs.filter(
      (j) => j.type === 'passp_clienti_sync' && j.status === 'completed'
    );
    if (syncJobs.length > 0) {
      setPage(0);
      fetchData();
      fetchTipoPersonaStats();
      if (showRegioneWidget) fetchRegioneStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobs]);

  const handleFilterTipoPersona = (event) => {
    setTipoPersona(event.target.value);
    setPage(0);
  };

  const handleOpenClientInvoices = async (row) => {
    setInvoiceClient(row);
    setInvoiceDrawerOpen(true);
    setInvoicePage(0);
    setInvoiceTypeFilter('all');
    setInvoiceOrder('desc');
    setInvoiceLoading(true);
    try {
      const res = await api.get(`/passp-clientes/${row.id}/invoices`);
      const data = res.data || {};
      setInvoiceRows(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      console.error('Error fetching invoices for client:', error);
      toast.error('Errore nel caricamento delle fatture del cliente');
    } finally {
      setInvoiceLoading(false);
    }
  };

  const handleCloseInvoiceDrawer = () => {
    setInvoiceDrawerOpen(false);
    setInvoiceClient(null);
    setInvoiceRows([]);
    setInvoicePage(0);
    setInvoiceTypeFilter('all');
    setInvoiceOrder('desc');
  };

  const handlePrintClientStatement = async (row) => {
    if (!row || !row.id) {
      toast.error('Cliente non valido per la stampa estratto conto');
      return;
    }
    try {
      const clienteLabel =
        row.ragione_sociale ||
        row.denominazione ||
        [row.cognome, row.nome].filter(Boolean).join(' ') ||
        row.codice ||
        'Cliente Passpartout';

      addMonitoringNotification({
        kind: 'passp_client_statement',
        clientId: row.id,
        clientName: clienteLabel,
        clientCode: row.codice || null,
      });
      toast.info('Estratto conto predisposto: usa la campanella per scaricare il PDF.', {
        position: 'top-right',
        autoClose: 3000,
      });
    } catch (error) {
      console.error('Error printing client statement:', error);
      toast.error('Errore nella generazione dell’estratto conto');
    }
  };

  const handleOpenInvoiceInFatture = (doc) => {
    navigate(
      `/passp-fatture?azienda=${encodeURIComponent(doc.azienda || '')}` +
        `&sigla=${encodeURIComponent(doc.sigla || '')}` +
        `&numero=${encodeURIComponent(doc.numero || '')}`
    );
  };

  const handlePrintInvoiceFromDrawer = async (doc) => {
    try {
      const res = await api.post(
        `/passp-fatture/${doc.id}/print`,
        { sendEmail: false },
        { responseType: 'blob' }
      );
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Error printing Passpartout document from drawer:', error);
      toast.error('Errore durante la stampa del documento');
    }
  };

  const handleInvoiceChangePage = (_event, newPage) => {
    setInvoicePage(newPage);
  };

  const handleInvoiceChangeRowsPerPage = (event) => {
    setInvoiceRowsPerPage(parseInt(event.target.value, 10));
    setInvoicePage(0);
  };

  const filteredInvoiceRows = useMemo(() => {
    const base =
      invoiceTypeFilter === 'all'
        ? invoiceRows
        : invoiceRows.filter((doc) => doc.sigla === invoiceTypeFilter);

    const sorted = [...base].sort((a, b) => {
      const da = a.data_documento ? new Date(a.data_documento).getTime() : 0;
      const db = b.data_documento ? new Date(b.data_documento).getTime() : 0;
      if (!Number.isFinite(da) || !Number.isFinite(db)) return 0;
      return invoiceOrder === 'desc' ? db - da : da - db;
    });

    return sorted;
  }, [invoiceRows, invoiceTypeFilter, invoiceOrder]);

  const visibleInvoiceRows = useMemo(
    () =>
      filteredInvoiceRows.slice(
        invoicePage * invoiceRowsPerPage,
        invoicePage * invoiceRowsPerPage + invoiceRowsPerPage
      ),
    [filteredInvoiceRows, invoicePage, invoiceRowsPerPage]
  );

  const invoiceTotals = useMemo(() => {
    const count = filteredInvoiceRows.length;
    const amount = filteredInvoiceRows.reduce((sum, doc) => {
      const v = Number(doc.totale_documento);
      return Number.isFinite(v) ? sum + v : sum;
    }, 0);
    return { count, amount };
  }, [filteredInvoiceRows]);

  useEffect(() => {
    setInvoicePage(0);
  }, [invoiceTypeFilter]);

  useEffect(() => {
    setInvoicePage(0);
  }, [invoiceOrder]);

  const toggleInvoiceOrder = () => {
    setInvoiceOrder((prev) => (prev === 'desc' ? 'asc' : 'desc'));
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [azienda, anno, tipoPersona, regioneFiltro]);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenColumnMenu = (event) => {
    setColumnMenuAnchorEl(event.currentTarget);
  };

  const handleCloseColumnMenu = () => {
    setColumnMenuAnchorEl(null);
  };

  const handleToggleColumn = (key) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const visibleRows = useMemo(
    () => rows,
    [rows]
  );

  const getTipoPersonaLabel = (value) => {
    if (value === 'S') return 'Persona fisica';
    if (value === 'N') return 'Azienda';
    return value || '-';
  };

  const selectedAzienda = useMemo(
    () => aziendeOptions.find((item) => item.code === azienda) || null,
    [aziendeOptions, azienda]
  );

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: '#eef2ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <PasspClientsLogoIcon size={20} color="#4f46e5" />
          </Box>
          <Box>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Clienti Passpartout
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Anagrafica clienti importata da Passpartout gestionale
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Button
            variant="outlined"
            onClick={handleOpenCreateCliente}
            startIcon={<Plus size={16} />}
            sx={{ textTransform: 'none' }}
          >
            Nuovo cliente
          </Button>
          <Button
            variant="contained"
            onClick={handleOpenSyncDialog}
            disabled={syncing}
            startIcon={
              syncing ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <RefreshCw size={16} />
              )
            }
            sx={{
              textTransform: 'none',
            }}
          >
            Sincronizza
          </Button>
        </Box>
      </Box>

      {loadingTipoPersonaStats ? (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={32} />
        </Box>
      ) : tipoPersonaStats.length > 0 ? (
        <Box sx={{ mb: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
            }}
          >
            {tipoPersonaStats.map((stat) => {
              const label =
                stat.tipo === 'S'
                  ? 'Persone fisiche'
                  : stat.tipo === 'N'
                  ? 'Persone giuridiche'
                  : stat.tipo || '-';
              const percentage =
                totalByTipoPersona > 0 ? (stat.count * 100) / totalByTipoPersona : 0;
              const visuals = getTipoPersonaVisuals(stat.tipo);
              const Icon = visuals.icon;
              const isActive = tipoPersona === stat.tipo;

              return (
                <Card
                  key={stat.tipo}
                  onClick={() => {
                    setTipoPersona(stat.tipo || 'all');
                    setShowFilters(true);
                    setPage(0);
                  }}
                  sx={{
                    flex: '1 1 220px',
                    borderRadius: 2,
                    boxShadow:
                      isActive
                        ? '0 0 0 1px rgba(37, 99, 235, 0.35), 0 12px 24px -4px rgba(15, 23, 42, 0.28)'
                        : '0 0 2px 0 rgba(145, 158, 171, 0.15), 0 12px 24px -6px rgba(145, 158, 171, 0.18)',
                    border: `1px solid ${isActive ? visuals.iconColor : visuals.borderColor}`,
                    cursor: 'pointer',
                    transition: 'all 0.15s ease-in-out',
                    '&:hover': {
                      boxShadow:
                        '0 0 0 1px rgba(148, 163, 184, 0.35), 0 16px 32px -6px rgba(15, 23, 42, 0.28)',
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexGrow: 1 }}>
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          backgroundColor: visuals.iconBg,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Icon size={20} color={visuals.iconColor} />
                      </Box>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          {label}
                        </Typography>
                        <Typography variant="h6">
                          {stat.count} clienti
                        </Typography>
                      </Box>
                    </Box>
                    <TipoPersonaDonut value={percentage} color={visuals.iconColor} />
                  </Box>
                </Card>
              );
            })}
          </Box>
        </Box>
      ) : null}

      <Box
        sx={{
          mb: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="subtitle2" color="text.secondary">
          Widget distribuzione regioni
        </Typography>
        <Tooltip title={showRegioneWidget ? 'Nascondi widget' : 'Mostra widget'}>
          <IconButton
            size="small"
            onClick={() => setShowRegioneWidget((prev) => !prev)}
            sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}
          >
            {showRegioneWidget ? <EyeOff size={16} /> : <Eye size={16} />}
          </IconButton>
        </Tooltip>
      </Box>

      <Collapse in={showRegioneWidget} timeout="auto" unmountOnExit>
      {loadingRegioneStats ? (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={32} />
        </Box>
      ) : regioneStats.length > 0 ? (
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Distribuzione per regione (clienti unici)
          </Typography>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow:
                '0 0 2px 0 rgba(145, 158, 171, 0.15), 0 12px 24px -6px rgba(145, 158, 171, 0.18)',
              border: '1px solid rgba(148, 163, 184, 0.25)',
            }}
          >
            <Box
              sx={{
                p: 2.5,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 999,
                    bgcolor:
                      regioneFiltro !== 'all'
                        ? 'rgba(37, 99, 235, 0.06)'
                        : 'rgba(148, 163, 184, 0.08)',
                    color:
                      regioneFiltro !== 'all'
                        ? 'primary.main'
                        : 'text.secondary',
                    fontWeight: 600,
                  }}
                >
                  {regioneFiltro !== 'all'
                    ? regioneFiltro
                    : 'Tutte le regioni'}
                </Typography>
              </Box>
              {(() => {
                const sorted = [...regioneStats].sort(
                  (a, b) => (b.count || 0) - (a.count || 0)
                );
                const maxPercentage = sorted.reduce((max, stat) => {
                  const value =
                    totalByRegione > 0 ? (stat.count * 100) / totalByRegione : 0;
                  return Math.max(max, value);
                }, 0) || 1;

                return (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: 2,
                      overflowX: 'auto',
                      pb: 1,
                    }}
                  >
                    {sorted.map((stat) => {
                      const percentage =
                        totalByRegione > 0 ? (stat.count * 100) / totalByRegione : 0;
                      const heightPercent = Math.max(
                        6,
                        (percentage / maxPercentage) * 100
                      );
                      const isActive = regioneFiltro === stat.regione;

                      return (
                        <Box
                          key={stat.regione}
                          onClick={() => {
                            setRegioneFiltro((prev) =>
                              prev === stat.regione ? 'all' : stat.regione
                            );
                            setShowFilters(true);
                            setPage(0);
                          }}
                          sx={{
                            minWidth: 40,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            cursor: 'pointer',
                            gap: 0.5,
                          }}
                        >
                          <Box
                            sx={{
                              height: 140,
                              display: 'flex',
                              alignItems: 'flex-end',
                            }}
                          >
                            <Box
                              sx={{
                                width: 20,
                                height: `${heightPercent}%`,
                                borderRadius: 999,
                                background: isActive
                                  ? 'linear-gradient(180deg, #2563EB, #10B981)'
                                  : 'rgba(148, 163, 184, 0.55)',
                                boxShadow: isActive
                                  ? '0 10px 18px rgba(15, 23, 42, 0.25)'
                                  : 'none',
                                transition: 'all 0.2s ease-out',
                              }}
                            />
                          </Box>
                          <Typography
                            variant="caption"
                            color={isActive ? 'primary' : 'text.secondary'}
                            sx={{
                              maxWidth: 56,
                              textAlign: 'center',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                            }}
                          >
                            {stat.regione}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ fontWeight: isActive ? 600 : 400 }}
                          >
                            {stat.count}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                );
              })()}
            </Box>
          </Card>
        </Box>
      ) : null}
      </Collapse>

      <Dialog
        open={syncDialogOpen}
        onClose={handleCloseSyncDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
              mt: 1,
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '999px',
                bgcolor: 'rgba(15, 23, 42, 0.06)',
                color: '#020617',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <RefreshCw size={20} />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Sincronizza clienti
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              Seleziona azienda e anno di esercizio da sincronizzare con Passpartout.
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <FormControl size="small" fullWidth>
              <InputLabel>Azienda</InputLabel>
              <Select
                value={syncAzienda}
                label="Azienda"
                onChange={(e) => setSyncAzienda(e.target.value)}
              >
                {aziendeOptions.map((item) => (
                  <MenuItem key={item.code} value={item.code}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" fullWidth>
              <InputLabel>Anno</InputLabel>
              <Select
                value={syncAnno}
                label="Anno"
                onChange={(e) => setSyncAnno(e.target.value)}
              >
                {anniOptions.map((year) => (
                  <MenuItem key={year} value={String(year)}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {syncAzienda && syncAnno ? (
              <>
                <FormControl component="fieldset">
                  <RadioGroup
                    value={syncMode}
                    onChange={(e) => setSyncMode(e.target.value)}
                  >
                    <FormControlLabel
                      value="incremental"
                      control={<Radio />}
                      label="Incrementale (da ultima modifica)"
                    />
                    <FormControlLabel
                      value="full"
                      control={<Radio />}
                      label="Completa (tutti i record)"
                    />
                  </RadioGroup>
                </FormControl>
                {syncMode === 'incremental' ? (
                  <Alert severity="info" sx={{ alignItems: 'center' }}>
                    {loadingSyncLatestDate ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={14} />
                        <Typography variant="body2">
                          Recupero ultima data modifica...
                        </Typography>
                      </Box>
                    ) : syncLatestDate ? (
                      `Verranno recuperati i clienti dal ${formatDisplayDate(syncLatestDate)} a oggi in base al campo data_ult_mod.`
                    ) : (
                      'Nessuna data modifica trovata: la sincronizzazione incrementale partirà da oggi.'
                    )}
                  </Alert>
                ) : null}
              </>
            ) : null}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSyncDialog} disabled={syncing}>
            Annulla
          </Button>
          <Button
            onClick={handleConfirmSync}
            variant="contained"
            disabled={syncing}
          >
            {syncing ? 'Sincronizzazione...' : 'Conferma'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={clienteDialogOpen}
        onClose={handleCloseClienteDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxWidth: '980px',
            width: 'calc(100vw - 48px)',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
              mt: 1,
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '999px',
                bgcolor: 'rgba(37, 99, 235, 0.08)',
                color: '#2563EB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {clienteDialogMode === 'create' ? <Plus size={20} /> : <Pencil size={20} />}
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {clienteDialogMode === 'create' ? 'Nuovo cliente' : 'Modifica cliente'}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              Compila i dati anagrafici. Il JSON resta disponibile in modalità avanzata.
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <FormControl size="small" sx={{ minWidth: 220, flex: '1 1 220px' }}>
                <InputLabel>Azienda</InputLabel>
                <Select
                  value={clienteDialogAzienda}
                  label="Azienda"
                  onChange={(e) => {
                    const value = e.target.value;
                    setClienteDialogAzienda(value);
                    if (clienteDialogMode !== 'create' || clienteDialogUseJson) return;
                    setClienteFormErrors((prev) => ({ ...prev, codice: false }));
                    setClienteCodiceManual(false);
                    (async () => {
                      const next = await fetchNextCodice(value, clienteDialogAnno);
                      setClienteForm((prev) => {
                        const merged = { ...prev, codice: next || '' };
                        if (!clienteDialogJsonTouched) {
                          setClienteDialogJson(JSON.stringify(buildClientePayloadFromForm(merged, { keepEmpty: false }), null, 2));
                        }
                        return merged;
                      });
                    })();
                  }}
                >
                  {aziendeOptions.map((item) => (
                    <MenuItem key={item.code} value={item.code}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 160, flex: '0 1 160px' }}>
                <InputLabel>Anno</InputLabel>
                <Select
                  value={clienteDialogAnno}
                  label="Anno"
                  onChange={(e) => {
                    const value = e.target.value;
                    setClienteDialogAnno(value);
                    if (clienteDialogMode !== 'create' || clienteDialogUseJson) return;
                    setClienteFormErrors((prev) => ({ ...prev, codice: false }));
                    setClienteCodiceManual(false);
                    (async () => {
                      const next = await fetchNextCodice(clienteDialogAzienda, value);
                      setClienteForm((prev) => {
                        const merged = { ...prev, codice: next || '' };
                        if (!clienteDialogJsonTouched) {
                          setClienteDialogJson(JSON.stringify(buildClientePayloadFromForm(merged, { keepEmpty: false }), null, 2));
                        }
                        return merged;
                      });
                    })();
                  }}
                >
                  {anniOptions.map((year) => (
                    <MenuItem key={year} value={String(year)}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {clienteDialogMode === 'edit' && clienteDialogCodice ? (
              <Alert severity="info" sx={{ alignItems: 'center' }}>
                {`Codice cliente: ${clienteDialogCodice}`}
              </Alert>
            ) : null}

            <TextField
              label="Codice cliente"
              value={clienteDialogMode === 'edit' ? clienteDialogCodice : clienteForm.codice}
              onChange={(e) => {
                if (clienteDialogMode === 'edit') return;
                const value = e.target.value;
                setClienteFormErrors((prev) => ({ ...prev, codice: false }));
                setClienteCodiceManual(true);
                setClienteCodiceHint({ lastCodice: '', nextCodice: '' });
                setClienteForm((prev) => {
                  const next = { ...prev, codice: value };
                  if (!clienteDialogJsonTouched) {
                    setClienteDialogJson(
                      JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                    );
                  }
                  return next;
                });
              }}
              error={Boolean(clienteDialogMode === 'create' && clienteFormErrors.codice)}
              helperText={
                clienteDialogMode === 'create' &&
                !clienteDialogUseJson &&
                clienteCodiceHint?.nextCodice &&
                clienteCodiceHint?.lastCodice
                  ? `Ultimo: ${clienteCodiceHint.lastCodice} · Proposto: ${clienteCodiceHint.nextCodice}`
                  : ''
              }
              size="small"
              fullWidth
              disabled={clienteDialogMode === 'edit'}
            />

            <FormControl component="fieldset">
              <RadioGroup
                row
                value={clienteForm.gest_per_fisica}
                onChange={(e) => {
                  const value = e.target.value === 'S' ? 'S' : 'N';
                  setClienteFormErrors({});
                  setClienteForm((prev) => {
                    const next = { ...prev, gest_per_fisica: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
              >
                <FormControlLabel value="N" control={<Radio />} label="Persona giuridica" />
                <FormControlLabel value="S" control={<Radio />} label="Persona fisica" />
              </RadioGroup>
            </FormControl>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <TextField
                label="Codice fiscale"
                value={clienteForm.codice_fiscale}
                onChange={(e) => {
                  const value = normalizeCodiceFiscale(e.target.value);
                  setClienteForm((prev) => {
                    const next = { ...prev, codice_fiscale: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                error={Boolean(clienteFormErrors.codice_fiscale)}
                size="small"
                sx={{ minWidth: 260, flex: '1 1 260px' }}
              />
              <TextField
                label="Partita IVA"
                value={clienteForm.partita_iva}
                onChange={(e) => {
                  const value = normalizePartitaIva(e.target.value);
                  setClienteForm((prev) => {
                    const next = { ...prev, partita_iva: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                error={Boolean(clienteFormErrors.partita_iva)}
                size="small"
                sx={{ minWidth: 220, flex: '1 1 220px' }}
              />
              <FormControl size="small" sx={{ minWidth: 200, flex: '0 1 200px' }}>
                <InputLabel>Nazionalità</InputLabel>
                <Select
                  label="Nazionalità"
                  value={clienteForm.tp_nazionalita}
                  onChange={(e) => {
                    const value = String(e.target.value || '').trim().toUpperCase();
                    setClienteForm((prev) => {
                      const next = { ...prev, tp_nazionalita: value };
                      if (!clienteDialogJsonTouched) {
                        setClienteDialogJson(
                          JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                        );
                      }
                      return next;
                    });
                  }}
                >
                  <MenuItem value="I">Italia</MenuItem>
                  <MenuItem value="C">UE</MenuItem>
                  <MenuItem value="E">Estero (no UE)</MenuItem>
                  <MenuItem value="R">RSM</MenuItem>
                  <MenuItem value="V">Vaticano</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {clienteForm.gest_per_fisica === 'S' ? (
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  label="Ragione sociale"
                  value={ragioneSocialeComputed}
                  disabled
                  size="small"
                  sx={{ minWidth: 320, flex: '2 1 320px' }}
                />
                <TextField
                  label="Cognome"
                  value={clienteForm.cognome}
                  onChange={(e) => {
                    const value = e.target.value;
                    setClienteForm((prev) => {
                      const next = { ...prev, cognome: value };
                      if (!clienteDialogJsonTouched) {
                        setClienteDialogJson(
                          JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                        );
                      }
                      return next;
                    });
                  }}
                  error={Boolean(clienteFormErrors.cognome)}
                  size="small"
                  sx={{ minWidth: 240, flex: '1 1 240px' }}
                />
                <TextField
                  label="Nome"
                  value={clienteForm.nome}
                  onChange={(e) => {
                    const value = e.target.value;
                    setClienteForm((prev) => {
                      const next = { ...prev, nome: value };
                      if (!clienteDialogJsonTouched) {
                        setClienteDialogJson(
                          JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                        );
                      }
                      return next;
                    });
                  }}
                  error={Boolean(clienteFormErrors.nome)}
                  size="small"
                  sx={{ minWidth: 200, flex: '1 1 200px' }}
                />
              </Box>
            ) : (
              <TextField
                label="Ragione sociale"
                value={clienteForm.ragione_sociale}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, ragione_sociale: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                error={Boolean(clienteFormErrors.ragione_sociale)}
                size="small"
                fullWidth
              />
            )}

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <TextField
                label="Indirizzo"
                value={clienteForm.indirizzo}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, indirizzo: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                size="small"
                sx={{ minWidth: 320, flex: '2 1 320px' }}
              />
              <TextField
                label="CAP"
                value={clienteForm.cap}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, cap: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                size="small"
                sx={{ width: 120 }}
              />
              <TextField
                label="Località"
                value={clienteForm.localita}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, localita: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                size="small"
                sx={{ minWidth: 220, flex: '1 1 220px' }}
              />
              <TextField
                label="Prov."
                value={clienteForm.provincia}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, provincia: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                size="small"
                sx={{ width: 90 }}
              />
            </Box>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <TextField
                label="Email"
                value={clienteForm.email}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, email: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                size="small"
                sx={{ minWidth: 260, flex: '1 1 260px' }}
              />
              <TextField
                label="PEC"
                value={clienteForm.pec}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, pec: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                size="small"
                sx={{ minWidth: 260, flex: '1 1 260px' }}
              />
              <TextField
                label="Telefono"
                value={clienteForm.telefono}
                onChange={(e) => {
                  const value = e.target.value;
                  setClienteForm((prev) => {
                    const next = { ...prev, telefono: value };
                    if (!clienteDialogJsonTouched) {
                      setClienteDialogJson(
                        JSON.stringify(buildClientePayloadFromForm(next, { keepEmpty: clienteDialogMode === 'edit' }), null, 2)
                      );
                    }
                    return next;
                  });
                }}
                size="small"
                sx={{ minWidth: 180, flex: '0 1 180px' }}
              />
            </Box>

            {clienteForm.gest_per_fisica === 'S' ? (
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  label="Nascita Comune-Stato estero"
                  value={clienteForm.loc_nasc_cost}
                  InputProps={{ readOnly: true }}
                  size="small"
                  sx={{ minWidth: 320, flex: '2 1 320px' }}
                />
                <TextField
                  label="Provincia nascita"
                  value={clienteForm.prv_nasc_cost}
                  InputProps={{ readOnly: true }}
                  size="small"
                  sx={{ width: 160 }}
                />
                <TextField
                  label="Data nascita"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={clienteForm.dt_nasc_cost}
                  InputProps={{ readOnly: true }}
                  size="small"
                  sx={{ width: 190 }}
                />
              </Box>
            ) : null}

            <FormControlLabel
              control={
                <Checkbox
                  checked={clienteDialogAdvanced}
                  onChange={(e) => {
                    const checked = Boolean(e.target.checked);
                    if (checked) {
                      syncJsonFromFormIfNeeded();
                    }
                    if (!checked) {
                      setClienteDialogUseJson(false);
                    }
                    setClienteDialogAdvanced(checked);
                  }}
                />
              }
              label="Avanzato (JSON)"
            />

            <Collapse in={clienteDialogAdvanced} timeout="auto" unmountOnExit>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Alert severity="info" sx={{ alignItems: 'center' }}>
                  Per default salva il form. Se vuoi forzare il JSON, attiva “Usa JSON per il salvataggio”.
                </Alert>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={clienteDialogUseJson}
                      onChange={(e) => setClienteDialogUseJson(Boolean(e.target.checked))}
                    />
                  }
                  label="Usa JSON per il salvataggio"
                />
                <TextField
                  label="Payload JSON"
                  value={clienteDialogJson}
                  onChange={(e) => {
                    setClienteDialogJsonTouched(true);
                    setClienteDialogJson(e.target.value);
                  }}
                  multiline
                  minRows={8}
                  fullWidth
                  size="small"
                  inputProps={{
                    style: {
                      fontFamily:
                        'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                      fontSize: 12,
                    },
                  }}
                />
              </Box>
            </Collapse>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseClienteDialog} disabled={clienteDialogSaving}>
            Annulla
          </Button>
          <Button
            onClick={handleSaveClienteDialog}
            variant="contained"
            disabled={clienteDialogSaving}
          >
            {clienteDialogSaving ? 'Salvataggio...' : 'Conferma'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={duplicateDialogOpen}
        onClose={handleCloseDuplicateDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Cliente già presente
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Alert severity="warning" sx={{ alignItems: 'center' }}>
              {duplicateDialogMessage || 'Trovato un cliente esistente con lo stesso identificativo.'}
            </Alert>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {duplicateDialogMatches.map((m, idx) => {
                const codice = getClienteCodiceFromMatch(m);
                const label = getClienteDisplayName(m);
                const piva = m?.partita_iva || m?.partitaIva || m?.piva || '';
                const cf = m?.codice_fiscale || m?.codiceFiscale || m?.cf || '';
                return (
                  <Card
                    key={`${codice || 'no-code'}-${idx}`}
                    variant="outlined"
                    sx={{ borderRadius: 2, p: 1.5 }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'flex-start' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                          {label}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {codice ? `Codice: ${codice}` : 'Codice: -'}
                          {(piva || cf) ? ` • ${[piva && `P.IVA: ${piva}`, cf && `CF: ${cf}`].filter(Boolean).join(' • ')}` : ''}
                        </Typography>
                      </Box>
                      <Button
                        variant="contained"
                        size="small"
                        disabled={!codice}
                        onClick={() => handleOpenEditFromDuplicateMatch(m)}
                        sx={{ textTransform: 'none' }}
                      >
                        Apri in modifica
                      </Button>
                    </Box>
                  </Card>
                );
              })}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDuplicateDialog} sx={{ textTransform: 'none' }}>
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>

      <StyledCard>
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              alignItems: 'center',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
            }}
          >
            <TextField
              fullWidth
              size="small"
              value={search}
              onChange={handleSearchChange}
              onKeyDown={handleSearchKeyDown}
              placeholder="Cerca per ragione sociale, denominazione, nominativo, email, P.IVA, CF..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search size={20} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          <IconButton onClick={() => setShowFilters(!showFilters)}>
                        <Badge
                          badgeContent={
                            (azienda !== 'all' ? 1 : 0) +
                            (anno !== 'all' ? 1 : 0) +
                                (tipoPersona !== 'all' ? 1 : 0) +
                                (regioneFiltro !== 'all' ? 1 : 0)
                          }
                          color="primary"
                        >
                          <FilterAltIcon
                            color={
                              showFilters ||
                              azienda !== 'all' ||
                              anno !== 'all' ||
                                  tipoPersona !== 'all' ||
                                  regioneFiltro !== 'all'
                                ? 'primary'
                                : 'action'
                            }
                          />
                        </Badge>
                      </IconButton>
                      <Tooltip title="Seleziona colonne aggiuntive">
                        <IconButton onClick={handleOpenColumnMenu}>
                          <ViewColumnIcon color={optionalColumnsActive ? 'primary' : 'action'} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </InputAdornment>
                ),
              }}
              sx={{ maxWidth: 400 }}
            />

            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
              <Chip
                label={
                  azienda === 'all'
                    ? 'Tutte le aziende'
                    : `Azienda: ${selectedAzienda ? selectedAzienda.name : azienda}`
                }
                variant="outlined"
                size="small"
              />
              <Chip
                label={
                  anno === 'all'
                    ? 'Tutti gli anni'
                    : `Anno: ${anno}`
                }
                variant="outlined"
                size="small"
              />
              <Chip
                label={
                  tipoPersona === 'all'
                    ? 'Tutti i tipi'
                    : getTipoPersonaLabel(tipoPersona)
                }
                variant="outlined"
                size="small"
              />
            </Box>
          </Box>

          {showFilters && (
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
              <FormControl size="small" sx={{ minWidth: 180 }}>
                <InputLabel>Azienda</InputLabel>
                <Select
                  value={azienda}
                  label="Azienda"
                  onChange={handleFilterAzienda}
                >
                  <MenuItem value="all">Tutte</MenuItem>
                  {aziendeOptions.map((item) => (
                    <MenuItem key={item.code} value={item.code}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 140 }}>
                <InputLabel>Anno</InputLabel>
                <Select
                  value={anno}
                  label="Anno"
                  onChange={handleFilterAnno}
                >
                  <MenuItem value="all">Tutti</MenuItem>
                  {anniOptions.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel>Tipo soggetto</InputLabel>
                <Select
                  value={tipoPersona}
                  label="Tipo soggetto"
                  onChange={handleFilterTipoPersona}
                >
                  <MenuItem value="all">Tutti</MenuItem>
                  {tipiPersonaOptions.map((item) => (
                    <MenuItem key={item} value={item}>
                      {getTipoPersonaLabel(item)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}

        </Box>

        <Menu
          anchorEl={columnMenuAnchorEl}
          open={Boolean(columnMenuAnchorEl)}
          onClose={handleCloseColumnMenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box sx={{ px: 2, pt: 1 }}>
            <Typography variant="caption" color="text.secondary">
              Colonne aggiuntive
            </Typography>
          </Box>
          <FormGroup sx={{ px: 2, pb: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={columnVisibility.id}
                  onChange={() => handleToggleColumn('id')}
                />
              }
              label="ID"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={columnVisibility.denominazione}
                  onChange={() => handleToggleColumn('denominazione')}
                />
              }
              label="Denominazione"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={columnVisibility.cognome}
                  onChange={() => handleToggleColumn('cognome')}
                />
              }
              label="Cognome"
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={columnVisibility.nome}
                  onChange={() => handleToggleColumn('nome')}
                />
              }
              label="Nome"
            />
          </FormGroup>
        </Menu>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'background.neutral' }}>
                <TableCell sx={{ width: 56 }} />
                {columnVisibility.id && (
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === 'id'}
                      direction={orderBy === 'id' ? order : 'asc'}
                      onClick={() => handleRequestSort('id')}
                    >
                      ID
                    </TableSortLabel>
                  </TableCell>
                )}
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'gest_per_fisica'}
                    direction={orderBy === 'gest_per_fisica' ? order : 'asc'}
                    onClick={() => handleRequestSort('gest_per_fisica')}
                  >
                    Tipo
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'ragione_sociale'}
                    direction={orderBy === 'ragione_sociale' ? order : 'asc'}
                    onClick={() => handleRequestSort('ragione_sociale')}
                  >
                    Cliente
                  </TableSortLabel>
                </TableCell>
                {columnVisibility.denominazione && (
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === 'denominazione'}
                      direction={orderBy === 'denominazione' ? order : 'asc'}
                      onClick={() => handleRequestSort('denominazione')}
                    >
                      Denominazione
                    </TableSortLabel>
                  </TableCell>
                )}
                {columnVisibility.cognome && (
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === 'cognome'}
                      direction={orderBy === 'cognome' ? order : 'asc'}
                      onClick={() => handleRequestSort('cognome')}
                    >
                      Cognome
                    </TableSortLabel>
                  </TableCell>
                )}
                {columnVisibility.nome && (
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === 'nome'}
                      direction={orderBy === 'nome' ? order : 'asc'}
                      onClick={() => handleRequestSort('nome')}
                    >
                      Nome
                    </TableSortLabel>
                  </TableCell>
                )}
                <TableCell>Località</TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'codice_fiscale'}
                    direction={orderBy === 'codice_fiscale' ? order : 'asc'}
                    onClick={() => handleRequestSort('codice_fiscale')}
                  >
                    P.IVA / CF
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'email'}
                    direction={orderBy === 'email' ? order : 'asc'}
                    onClick={() => handleRequestSort('email')}
                  >
                    Contatti
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'azienda'}
                    direction={orderBy === 'azienda' ? order : 'asc'}
                    onClick={() => handleRequestSort('azienda')}
                  >
                    Azienda / Anno
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={totalColumns} align="center" sx={{ py: 3 }}>
                    <LoaderProgress size={50} />
                  </TableCell>
                </TableRow>
              ) : visibleRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={totalColumns} align="center" sx={{ py: 3 }}>
                    <Typography variant="body1" color="text.secondary">
                      Nessun cliente trovato
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                visibleRows.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell padding="checkbox">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Tooltip title="Visualizza fatture del cliente">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenClientInvoices(row)}
                              sx={{ color: '#4b5563' }}
                            >
                              <FileTextIcon size={16} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Stampa estratto conto cliente in PDF">
                            <IconButton
                              size="small"
                              onClick={() => handlePrintClientStatement(row)}
                              sx={{ color: '#dc2626' }}
                            >
                              <PictureAsPdfIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Modifica cliente su Passpartout">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenEditCliente(row)}
                              sx={{ color: '#2563EB' }}
                            >
                              <Pencil size={16} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    {columnVisibility.id && <TableCell>{row.id}</TableCell>}
                    <TableCell sx={{ maxWidth: 140 }}>
                      <Chip
                        label={getTipoPersonaLabel(row.gest_per_fisica)}
                        size="small"
                        color={row.gest_per_fisica === 'S' ? 'primary' : 'default'}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell sx={{ maxWidth: 260 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 'bold' }}
                        noWrap
                      >
                        {row.ragione_sociale ||
                          row.denominazione ||
                          [row.cognome, row.nome].filter(Boolean).join(' ') ||
                          '-'}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        noWrap
                      >
                        {row.codice ? `Codice: ${row.codice}` : ''}
                      </Typography>
                    </TableCell>
                    {columnVisibility.denominazione && (
                      <TableCell sx={{ maxWidth: 200 }}>
                        <Typography variant="body2" noWrap>
                          {row.denominazione || '-'}
                        </Typography>
                      </TableCell>
                    )}
                    {columnVisibility.cognome && (
                      <TableCell sx={{ maxWidth: 160 }}>
                        <Typography variant="body2" noWrap>
                          {row.cognome || '-'}
                        </Typography>
                      </TableCell>
                    )}
                    {columnVisibility.nome && (
                      <TableCell sx={{ maxWidth: 140 }}>
                        <Typography variant="body2" noWrap>
                          {row.nome || '-'}
                        </Typography>
                      </TableCell>
                    )}
                    <TableCell sx={{ maxWidth: 260 }}>
                      {[
                        row.indirizzo,
                        row.cap,
                        row.localita,
                        row.provincia,
                      ]
                        .filter(Boolean)
                        .join(' - ') || '-'}
                    </TableCell>
                    <TableCell sx={{ maxWidth: 220 }}>
                      <Typography variant="body2" noWrap>
                        {row.partita_iva || row.codice_fiscale || '-'}
                      </Typography>
                      {row.partita_iva && row.codice_fiscale && (
                        <Typography variant="caption" color="text.secondary" noWrap>
                          {row.partita_iva && `P.IVA: ${row.partita_iva}`}
                          {row.partita_iva && row.codice_fiscale && ' • '}
                          {row.codice_fiscale && `CF: ${row.codice_fiscale}`}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell sx={{ maxWidth: 260 }}>
                      <Tooltip
                        title={[
                          row.email,
                          row.telefono,
                          row.pec,
                        ]
                          .filter(Boolean)
                          .join(' • ')}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          {row.email && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <EmailIcon fontSize="small" />
                              <Typography variant="body2" noWrap>
                                {row.email}
                              </Typography>
                            </Box>
                          )}
                          {row.telefono && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <PhoneIcon fontSize="small" />
                              <Typography variant="body2" noWrap>
                                {row.telefono}
                              </Typography>
                            </Box>
                          )}
                          {row.pec && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <MarkEmailReadIcon fontSize="small" />
                              <Typography variant="body2" noWrap>
                                {row.pec}
                              </Typography>
                            </Box>
                          )}
                          {!row.email && !row.telefono && !row.pec && (
                            <Typography variant="body2" noWrap>
                              -
                            </Typography>
                          )}
                        </Box>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ maxWidth: 180 }}>
                      <Typography variant="body2" noWrap>
                        {row.azienda || '-'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" noWrap>
                        {row.anno ? `Anno: ${row.anno}` : ''}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={totalItems}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Righe per pagina:"
        />
      </StyledCard>

      <Drawer
        anchor="right"
        open={invoiceDrawerOpen}
        onClose={handleCloseInvoiceDrawer}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 520, md: 620 },
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
            Documenti cliente
          </Typography>
          {invoiceClient && (
            <Typography variant="body2" color="text.secondary">
              {invoiceClient.ragione_sociale ||
                invoiceClient.denominazione ||
                [invoiceClient.cognome, invoiceClient.nome].filter(Boolean).join(' ') ||
                '-'}
              {invoiceClient.codice && ` • Codice: ${invoiceClient.codice}`}
              {invoiceClient.partita_iva && ` • P.IVA: ${invoiceClient.partita_iva}`}
              {invoiceClient.codice_fiscale &&
                ` • CF: ${invoiceClient.codice_fiscale}`}
            </Typography>
          )}
        </Box>
        <Divider />
        <Box sx={{ p: 2, pt: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              mb: 2,
            }}
          >
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Chip
                label="Tutti"
                size="small"
                clickable
                color={invoiceTypeFilter === 'all' ? 'primary' : 'default'}
                variant={invoiceTypeFilter === 'all' ? 'filled' : 'outlined'}
                onClick={() => setInvoiceTypeFilter('all')}
              />
              <Chip
                label="Fatture (FT)"
                size="small"
                clickable
                color={invoiceTypeFilter === 'FT' ? 'primary' : 'default'}
                variant={invoiceTypeFilter === 'FT' ? 'filled' : 'outlined'}
                onClick={() => setInvoiceTypeFilter('FT')}
              />
              <Chip
                label="Note credito (NC)"
                size="small"
                clickable
                color={invoiceTypeFilter === 'NC' ? 'primary' : 'default'}
                variant={invoiceTypeFilter === 'NC' ? 'filled' : 'outlined'}
                onClick={() => setInvoiceTypeFilter('NC')}
              />
            </Box>
            <Typography variant="body2" color="text.secondary">
              Totale documenti: <strong>{invoiceTotals.count}</strong>
              {invoiceTotals.amount
                ? ` • Totale importi: ${invoiceTotals.amount.toLocaleString('it-IT', {
                    style: 'currency',
                    currency: 'EUR',
                  })}`
                : ''}
            </Typography>
          </Box>
          {invoiceLoading ? (
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress size={32} />
            </Box>
          ) : invoiceRows.length === 0 ? (
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                Nessuna fattura trovata per questo cliente.
              </Typography>
            </Box>
          ) : (
            <>
              <TableContainer sx={{ flexGrow: 1 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        <TableSortLabel
                          active
                          direction={invoiceOrder}
                          onClick={toggleInvoiceOrder}
                        >
                          Data
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Azienda</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Tipo</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Doc.</TableCell>
                      <TableCell sx={{ fontWeight: 600 }} align="right">
                        Importo
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }} align="right">
                        Azioni
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {visibleInvoiceRows.map((doc) => (
                      <TableRow key={doc.id} hover>
                        <TableCell>
                          {doc.data_documento
                            ? new Date(doc.data_documento).toLocaleDateString('it-IT')
                            : '-'}
                        </TableCell>
                        <TableCell>{doc.azienda || '-'}</TableCell>
                        <TableCell>
                          <Chip
                            label={doc.sigla || '-'}
                            size="small"
                            color={doc.sigla === 'NC' ? 'error' : 'default'}
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          {doc.sigla || ''}{' '}
                          {doc.serie_numero ||
                            [doc.serie, doc.numero].filter(Boolean).join('/')}
                        </TableCell>
                        <TableCell align="right">
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 500,
                              color:
                                (Number(doc.totale_documento) || 0) < 0
                                  ? 'error.main'
                                  : 'success.main',
                            }}
                          >
                            {Number.isFinite(Number(doc.totale_documento))
                              ? Number(doc.totale_documento).toLocaleString('it-IT', {
                                  style: 'currency',
                                  currency: 'EUR',
                                })
                              : '-'}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Tooltip title="Apri in Fatture Passpartout">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenInvoiceInFatture(doc)}
                              sx={{ mr: 0.5 }}
                            >
                              <OpenInNewIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Stampa documento (PDF)">
                            <IconButton
                              size="small"
                              onClick={() => handlePrintInvoiceFromDrawer(doc)}
                            >
                              <PictureAsPdfIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={filteredInvoiceRows.length}
                rowsPerPage={invoiceRowsPerPage}
                page={invoicePage}
                onPageChange={handleInvoiceChangePage}
                onRowsPerPageChange={handleInvoiceChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Righe per pagina:"
              />
            </>
          )}
        </Box>
      </Drawer>

    </Box>
  );
}
